import { takeEvery, put, call, all, fork } from "redux-saga/effects"
import { addNewTypeProperty, getTypeProperties, updateTypeProperty, deleteTypeProperty } from "../../helpers/backend_helper"
import { ACTION_GET_TYPE_PROPERTIES_SELECT, actionGetTypePropertiesSelectSuccess, ADD_NEW_TYPE_PROPERTY, addTypePropertySuccess, DELETE_TYPE_PROPERTY, deleteTypePropertySuccess, GET_TYPE_PROPERTIES, getTypeProperties3Success, getTypePropertiesFail, getTypePropertiesSuccess, modalTypePropertyShow, UPDATE_TYPE_PROPERTY, updateTypePropertySuccess } from "./actions"
import toastr from "toastr";


/**
 * Get all active type properties 
 */
function* fetchTypeProperties({ payload: filter }) {
    try {
      const response = yield call(getTypeProperties, filter)
      if(response.success) {
        if(response.data.getLevel3)
          yield put(getTypeProperties3Success(response))
        else {
          yield put(getTypePropertiesSuccess(response))
        }
      } else {
        toastr.error(response.message)
      }
    } catch (error) {
      yield put(getTypePropertiesFail(error))
    }
}

/**
 * Get all active type properties 
 */
function* fetchTypePropertiesSelect({ payload: filter }) {
    try {
      const response = yield call(getTypeProperties, filter)
      if(response.success) {
        if(response.data.getLevel3)
          yield put(getTypeProperties3Success(response))
        else {
          yield put(actionGetTypePropertiesSelectSuccess(response))
        }
      } else {
        toastr.error(response.message)
      }
    } catch (error) {
      yield put(getTypePropertiesFail(error))
    }
}

function* onAddNewTypeProperty({ payload: area }) {
    try {
      const response = yield call(addNewTypeProperty, area)
      if(response.success) {
        toastr.success(response.message)
        //yield put(addTypePropertySuccess(response))
        yield put(modalTypePropertyShow(false))
        //yield put(getTypeProperties(response))
      } else {
        toastr.error(response.message)
      }
    } catch (error) {
      //yield put(actionFail(error))
        console.log(error)
      toastr.error("Se ha producido un error, intenta nuevamente o contacta con el administrador")
    }
}


function* onUpdateTypeProperty({ payload: area }) {
    try {
      const response = yield call(updateTypeProperty, area)
      if(response.success) {
        toastr.success(response.message)
        //yield put(addTypePropertySuccess(response))
        yield put(modalTypePropertyShow(false))
        //yield put(getTypeProperties(response))
      } else {
        toastr.error(response.message)
      }
    } catch (error) {
      //yield put(actionFail(error))
        console.log(error)
      toastr.error("Se ha producido un error, intenta nuevamente o contacta con el administrador")
    }
}
  
function* onDeleteTypeProperty({ payload: area }) {
    try {
      const response = yield call(deleteTypeProperty, area)
      yield put(deleteTypePropertySuccess(response))
    } catch (error) {
      //yield put(deleteEventFail(error))
    }
}

  export function* watchTypePropertySaga() {
    yield takeEvery(GET_TYPE_PROPERTIES, fetchTypeProperties)
    yield takeEvery(ACTION_GET_TYPE_PROPERTIES_SELECT, fetchTypePropertiesSelect)
    yield takeEvery(ADD_NEW_TYPE_PROPERTY, onAddNewTypeProperty)
    yield takeEvery(UPDATE_TYPE_PROPERTY, onUpdateTypeProperty)
    yield takeEvery(DELETE_TYPE_PROPERTY, onDeleteTypeProperty) 
}

function* typePropertySaga() {
    yield all([fork(watchTypePropertySaga)]);
}

export default typePropertySaga;
